import { Stack } from '@findy-code/yuffie/ui/stack';
import { FaChevronDown } from 'react-icons/fa';

import type { HandleClickLikeParams } from '../../../types';
import { CloseButton } from '../components/close-button';
import { KeepButton } from '../keep-button';
import { LikeButton } from '../like-button';
import styles from './received-like-button-group.component.module.scss';

type Props = {
  companyName: string;
  isBlockCompany?: boolean;
  isKeep: boolean;
  isOpen?: boolean;
  isUserSuccessCommitmentJobInterview?: boolean;
  jobDescription: { id: number; jdHash: string };
  jobDescriptionLike:
    | { likeHash: string; likeExpirationDate: string }
    | null
    | undefined;
  onClickLike?: (params: HandleClickLikeParams) => void;
  onClickKeep?: (likeHash: string, isKeep: boolean) => void;
  onClose?: () => void;
};

export const ReceivedLikeButtonGroup = ({
  companyName,
  isKeep,
  isBlockCompany,
  isOpen,
  isUserSuccessCommitmentJobInterview,
  jobDescription,
  jobDescriptionLike,
  onClickLike,
  onClickKeep,
  onClose,
}: Props) => {
  const openClass = isOpen ? 'open' : undefined;

  return (
    <div className={`${openClass} ${styles.buttonGroupWrapper}`}>
      <div className={styles.receivedLikeButtonGroupWrapper}>
        {isUserSuccessCommitmentJobInterview && (
          <div className={styles.userSuccessCommitmentJobInterviewWrapper}>
            <p className={styles.userSuccessCommitmentJobInterviewText}>
              面談確約
            </p>
          </div>
        )}
        <div>
          <p className={styles.receivedLikeButtonGroupMessage}>
            {`${companyName}からあなた宛に`}
            <br />
            いいねが届いています!
          </p>
          <p className={styles.receivedLikeButtonGroupSPHiddenMessage}>
            気になったら「いいかも」を押してみましょう。
            企業とのメッセージが開始されます。
          </p>
        </div>

        <Stack
          className={styles.receivedLikeButtonWrapper}
          spacing={{ base: 8, md: 4 }}
        >
          <div className={openClass}>
            <LikeButton
              disabledMessage={
                isBlockCompany
                  ? '企業をブロックしているため「いいかも」を送ることができません'
                  : ''
              }
              isSent={false}
              jobDescription={jobDescription}
              onClick={onClickLike}
            />
            <KeepButton
              isKeep={isKeep}
              likeHash={jobDescriptionLike?.likeHash ?? ''}
              onClick={onClickKeep}
            />
          </div>
          {jobDescriptionLike?.likeExpirationDate && (
            <p className={styles.likeExpirationDate}>
              いいねの有効期限: {jobDescriptionLike.likeExpirationDate}
            </p>
          )}
        </Stack>
      </div>

      <CloseButton
        aria-label="閉じる"
        className={openClass}
        type="button"
        onClick={onClose}
      >
        <FaChevronDown aria-hidden="true" size="16" />
      </CloseButton>
    </div>
  );
};
